define [], () ->
  name: 'view_only', url: '^/view-only/{application_id}/{shareToken}/'
  template: require("./view_only.jade")
  controller: require("./view_only.coffee")
  params:
    shareToken: {squash: true, value: null}
    context: null
  public: true
  children: [
    name: 'application'
    controller: require('./../dashboard/view/application/application.coffee')
    template: require('./../dashboard/view/application/application.jade')
    params:
      application: null
  ,
    name: 'reports'
    controller: require('./../dashboard/view/reports/reports.coffee')
    template: require('./../dashboard/view/reports/reports.jade')
    params:
      application: null
      profile: null
  ]



// WEBPACK FOOTER //
// ./components/view_only/routes.coffee